export const RedbookFaceList = [
  {
    "index": 0,
    "val": "[微笑R]"
  },
  {
    "index": 1,
    "val": "[害羞R]"
  },
  {
    "index": 2,
    "val": "[失望R]"
  },
  {
    "index": 3,
    "val": "[汗颜R]"
  },
  {
    "index": 4,
    "val": "[哇R]"
  },
  {
    "index": 5,
    "val": "[喝奶茶R]"
  },
  {
    "index": 6,
    "val": "[自拍R]"
  },
  {
    "index": 7,
    "val": "[偷笑R]"
  },
  {
    "index": 8,
    "val": "[飞吻R]"
  },
  {
    "index": 9,
    "val": "[石化R]"
  },
  {
    "index": 10,
    "val": "[笑哭R]"
  },
  {
    "index": 11,
    "val": "[赞R]"
  },
  {
    "index": 12,
    "val": "[蹲后续H]"
  },
  {
    "index": 13,
    "val": "[暗中观察R]"
  },
  {
    "index": 14,
    "val": "[买爆R]"
  },
  {
    "index": 15,
    "val": "[大笑R]"
  },
  {
    "index": 16,
    "val": "[色色R]"
  },
  {
    "index": 17,
    "val": "[生气R]"
  },
  {
    "index": 18,
    "val": "[哭惹R]"
  },
  {
    "index": 19,
    "val": "[萌萌哒R]"
  },
  {
    "index": 20,
    "val": "[斜眼R]"
  },
  {
    "index": 21,
    "val": "[可怜R]"
  },
  {
    "index": 22,
    "val": "[鄙视R]"
  },
  {
    "index": 23,
    "val": "[皱眉R]"
  },
  {
    "index": 24,
    "val": "[抓狂R]"
  },
  {
    "index": 25,
    "val": "[捂脸R]"
  },
  {
    "index": 26,
    "val": "[派对R]"
  },
  {
    "index": 27,
    "val": "[吧唧R]"
  },
  {
    "index": 28,
    "val": "[惊恐R]"
  },
  {
    "index": 29,
    "val": "[抠鼻R]"
  },
  {
    "index": 30,
    "val": "[再见R]"
  },
  {
    "index": 31,
    "val": "[叹气R]"
  },
  {
    "index": 32,
    "val": "[睡觉R]"
  },
  {
    "index": 33,
    "val": "[得意R]"
  },
  {
    "index": 34,
    "val": "[吃瓜R]"
  },
  {
    "index": 35,
    "val": "[扶墙R]"
  },
  {
    "index": 36,
    "val": "[黑薯问号R]"
  },
  {
    "index": 37,
    "val": "[黄金薯R]"
  },
  {
    "index": 38,
    "val": "[吐舌头H]"
  },
  {
    "index": 39,
    "val": "[扯脸H]"
  },
  {
    "index": 40,
    "val": "[doge]"
  },
  {
    "index": 41,
    "val": "[天幕R]"
  },
  {
    "index": 42,
    "val": "[卡式炉R]"
  },
  {
    "index": 43,
    "val": "[折叠椅R]"
  },
  {
    "index": 44,
    "val": "[营地车R]"
  },
  {
    "index": 45,
    "val": "[露营灯R]"
  },
  {
    "index": 46,
    "val": "[露营R]"
  },
  {
    "index": 47,
    "val": "[渔夫帽R]"
  },
  {
    "index": 48,
    "val": "[登山鞋R]"
  },
  {
    "index": 49,
    "val": "[背包R]"
  },
  {
    "index": 50,
    "val": "[马甲R]"
  },
  {
    "index": 51,
    "val": "[骑行服R]"
  },
  {
    "index": 52,
    "val": "[手套R]"
  },
  {
    "index": 53,
    "val": "[头盔R]"
  },
  {
    "index": 54,
    "val": "[风镜R]"
  },
  {
    "index": 55,
    "val": "[公路车R]"
  },
  {
    "index": 56,
    "val": "[折叠车R]"
  },
  {
    "index": 57,
    "val": "[飞盘R]"
  },
  {
    "index": 58,
    "val": "[冲浪板R]"
  },
  {
    "index": 59,
    "val": "[双翘滑板R]"
  },
  {
    "index": 60,
    "val": "[陆冲板R]"
  },
  {
    "index": 61,
    "val": "[长板R]"
  },
  {
    "index": 62,
    "val": "[种草R]"
  },
  {
    "index": 63,
    "val": "[拔草R]"
  },
  {
    "index": 64,
    "val": "[点赞R]"
  },
  {
    "index": 65,
    "val": "[向右R]"
  },
  {
    "index": 66,
    "val": "[合十R]"
  },
  {
    "index": 67,
    "val": "[okR]"
  },
  {
    "index": 68,
    "val": "[加油R]"
  },
  {
    "index": 69,
    "val": "[握手R]"
  },
  {
    "index": 70,
    "val": "[鼓掌R]"
  },
  {
    "index": 71,
    "val": "[弱R]"
  },
  {
    "index": 72,
    "val": "[耶R]"
  },
  {
    "index": 73,
    "val": "[抱拳R]"
  },
  {
    "index": 74,
    "val": "[勾引R]"
  },
  {
    "index": 75,
    "val": "[拳头R]"
  },
  {
    "index": 76,
    "val": "[拥抱R]"
  },
  {
    "index": 77,
    "val": "[举手R]"
  },
  {
    "index": 78,
    "val": "[猪头R]"
  },
  {
    "index": 79,
    "val": "[老虎R]"
  },
  {
    "index": 80,
    "val": "[集美R]"
  },
  {
    "index": 81,
    "val": "[仙女R]"
  },
  {
    "index": 82,
    "val": "[红书R]"
  },
  {
    "index": 83,
    "val": "[开箱R]"
  },
  {
    "index": 84,
    "val": "[探店R]"
  },
  {
    "index": 85,
    "val": "[ootdR]"
  },
  {
    "index": 86,
    "val": "[同款R]"
  },
  {
    "index": 87,
    "val": "[打卡R]"
  },
  {
    "index": 88,
    "val": "[飞机R]"
  },
  {
    "index": 89,
    "val": "[拍立得R]"
  },
  {
    "index": 90,
    "val": "[薯券R]"
  },
  {
    "index": 91,
    "val": "[优惠券R]"
  },
  {
    "index": 92,
    "val": "[购物车R]"
  },
  {
    "index": 93,
    "val": "[kissR]"
  },
  {
    "index": 94,
    "val": "[礼物R]"
  },
  {
    "index": 95,
    "val": "[生日蛋糕R]"
  },
  {
    "index": 96,
    "val": "[私信R]"
  },
  {
    "index": 97,
    "val": "[请文明R]"
  },
  {
    "index": 98,
    "val": "[请友好R]"
  },
  {
    "index": 99,
    "val": "[氛围感R]"
  },
  {
    "index": 100,
    "val": "[清单R]"
  },
  {
    "index": 101,
    "val": "[电影R]"
  },
  {
    "index": 102,
    "val": "[学生党R]"
  },
  {
    "index": 103,
    "val": "[彩虹R]"
  },
  {
    "index": 104,
    "val": "[爆炸R]"
  },
  {
    "index": 105,
    "val": "[炸弹R]"
  },
  {
    "index": 106,
    "val": "[火R]"
  },
  {
    "index": 107,
    "val": "[啤酒R]"
  },
  {
    "index": 108,
    "val": "[咖啡R]"
  },
  {
    "index": 109,
    "val": "[钱袋R]"
  },
  {
    "index": 110,
    "val": "[流汗R]"
  },
  {
    "index": 111,
    "val": "[发R]"
  },
  {
    "index": 112,
    "val": "[红包R]"
  },
  {
    "index": 113,
    "val": "[福R]"
  },
  {
    "index": 114,
    "val": "[鞭炮R]"
  },
  {
    "index": 115,
    "val": "[庆祝R]"
  },
  {
    "index": 116,
    "val": "[烟花R]"
  },
  {
    "index": 117,
    "val": "[气球R]"
  },
  {
    "index": 118,
    "val": "[看R]"
  },
  {
    "index": 119,
    "val": "[新月R]"
  },
  {
    "index": 120,
    "val": "[满月R]"
  },
  {
    "index": 121,
    "val": "[大便R]"
  },
  {
    "index": 122,
    "val": "[太阳R]"
  },
  {
    "index": 123,
    "val": "[晚安R]"
  },
  {
    "index": 124,
    "val": "[星R]"
  },
  {
    "index": 125,
    "val": "[玫瑰R]"
  },
  {
    "index": 126,
    "val": "[凋谢R]"
  },
  {
    "index": 127,
    "val": "[郁金香R]"
  },
  {
    "index": 128,
    "val": "[樱花R]"
  },
  {
    "index": 129,
    "val": "[海豚R]"
  },
  {
    "index": 130,
    "val": "[放大镜R]"
  },
  {
    "index": 131,
    "val": "[刀R]"
  },
  {
    "index": 132,
    "val": "[辣椒R]"
  },
  {
    "index": 133,
    "val": "[黄瓜R]"
  },
  {
    "index": 134,
    "val": "[葡萄R]"
  },
  {
    "index": 135,
    "val": "[草莓R]"
  },
  {
    "index": 136,
    "val": "[桃子R]"
  },
  {
    "index": 137,
    "val": "[红薯R]"
  },
  {
    "index": 138,
    "val": "[栗子R]"
  },
  {
    "index": 139,
    "val": "[红色心形R]"
  },
  {
    "index": 140,
    "val": "[黄色心形R]"
  },
  {
    "index": 141,
    "val": "[绿色心形R]"
  },
  {
    "index": 142,
    "val": "[蓝色心形R]"
  },
  {
    "index": 143,
    "val": "[紫色心形R]"
  },
  {
    "index": 144,
    "val": "[爱心R]"
  },
  {
    "index": 145,
    "val": "[两颗心R]"
  },
  {
    "index": 146,
    "val": "[浅肤色R]"
  },
  {
    "index": 147,
    "val": "[中浅肤色R]"
  },
  {
    "index": 148,
    "val": "[中等肤色R]"
  },
  {
    "index": 149,
    "val": "[中深肤色R]"
  },
  {
    "index": 150,
    "val": "[有R]"
  },
  {
    "index": 151,
    "val": "[可R]"
  },
  {
    "index": 152,
    "val": "[蹲R]"
  },
  {
    "index": 153,
    "val": "[零R]"
  },
  {
    "index": 154,
    "val": "[一R]"
  },
  {
    "index": 155,
    "val": "[二R]"
  },
  {
    "index": 156,
    "val": "[三R]"
  },
  {
    "index": 157,
    "val": "[四R]"
  },
  {
    "index": 158,
    "val": "[五R]"
  },
  {
    "index": 159,
    "val": "[六R]"
  },
  {
    "index": 160,
    "val": "[七R]"
  },
  {
    "index": 161,
    "val": "[八R]"
  },
  {
    "index": 162,
    "val": "[九R]"
  },
  {
    "index": 163,
    "val": "[加一R]"
  },
  {
    "index": 164,
    "val": "[满R]"
  },
  {
    "index": 165,
    "val": "[禁R]"
  }
];
  
  export const Redbook_Face_Texts = RedbookFaceList.map((face) => {
    return face.val;
  });
  

function escapeRegExp(str: string) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

export function redbookFaceToHtml(text: string): string {
  if (!text.includes("[") || !text.includes("]")) return text;

  Redbook_Face_Texts.forEach((token: string, index: number) => {
    const re = new RegExp(escapeRegExp(token), "g");

    const config: any = RedbookFaceList.find((config) => config.val === token);
    text = text.replace(
      re,
      `<img  src="https://${window.location.host}/redbook_face/${config.index}.png" style="width: 25px"> `
    );
  });

  return text;
}
